// extracted by css-extract-rspack-plugin
export default {"metricPill":"ClXXe","menuTarget":"SUXGG"};